const TOKEN_KEY = 'userAccess';

const getToken = () => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      localStorage.removeItem(TOKEN_KEY);
      return false;
    }
    return token;
  }
  return false;
};

export { getToken};
